
class EyeConstructor {
  constructor() {
    this.eyeParameterList = null;
    this.eyePicList = null;
    this.bercEyePicList = null; // for BER eye diagram
  }

  updateEyeParamList(eyeParamList) {
    if (this.eyeParameterList) {
      const updateData = new Map([...this.eyeParameterList.getData(), ...eyeParamList.getData()]);
      this.eyeParameterList.updateData(updateData);
    } else {
      this.eyeParameterList = eyeParamList; // DdrResultEyeParam class
    }
  };

  updateEyePinList(eyePicList) {
    if (this.eyePicList) {
      const updateData = new Map([...this.eyePicList.getData(), ...eyePicList.getData()]);
      this.eyePicList.updateData(updateData);
    } else {
      this.eyePicList = eyePicList;  // DdrResultEyePic class
    }
  }

  updateBercEyePicList(bercEyePicList) {
    if (this.bercEyePicList) {
      const updateData = new Map([...this.bercEyePicList.getData(), ...bercEyePicList.getData()]);
      this.bercEyePicList.updateData(updateData);
    } else {
      this.bercEyePicList = bercEyePicList; // DdrResultEyePic class for BER eye
    }
  }
};

export default EyeConstructor;